import HeroSection from "./components/HeroSection/HeroSection";

function App() {
  return (
    <>
      <HeroSection />
    </>
  );
}

export default App;
